import { axiosInstance } from '~/services';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { TypeGetOwnerManagerDetailResponse } from '~/types/vender.types';

/**
 * [개인정보관리] 개인정보 조회
 */
const useGetOwnerManagerDetail = () => {
  const endPoint = '/api-owner/owner-manager/detail';

  const getOwnerManagerDetail = async () => {
    return axiosInstance
      .get<TypeGetOwnerManagerDetailResponse>(endPoint)
      .then(({ data }) => {
        return data.data;
      })
      .catch((error: TypeErrorResponseData['error']) => {
        throw error;
      });
  };

  return { getOwnerManagerDetail };
};

export default useGetOwnerManagerDetail;
